import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import NavBar from './components/NavBar'
import '../src/styles/home.css'
import Footer from './components/Footer'
import { motion } from "motion/react"
import ScrollToTop from './components/extra/ScrollToTop'

function Root() {
    

    return (
        <>
            <ScrollToTop>
            <Outlet />
      </ScrollToTop>
            <NavBar />
            <Footer />
        </>
    )
}

export default Root
